export default {
  title: 'orange',

  twitter: '#f45d22',
  twitter_dark_hover: 'rgba(244, 93, 34, .1)',
  twitter_light_hover: '#dc551f',
}